import { createSlice } from "@reduxjs/toolkit";

const initialState = ''

export const selectedMcpSlice = createSlice({
    name: 'selectedMcp',
    initialState: initialState,
    reducers:{
        editarSelectedMcp: (state, action) => {            
            return action.payload
        }
    }
})

export const { editarSelectedMcp } = selectedMcpSlice.actions

export default selectedMcpSlice.reducer